module.exports = {"id":"207559","name":"Simon Tibbling","rating":"72","photo":"./data/images/photos/4/207559.png","club":{"name":"Brøndby IF","logo":"./data/images/clubs/BrøndbyIF.png"},"positions":["MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SimonTibbling0.json
// module id = 3967
// module chunks = 0